<div class="p-grid">
    <div class="p-col-1">
        <label style="line-height: 2.5;">Filter: </label>
    </div>
    <div class="p-col-3">
        <p-dropdown [options]="allModuleNames" [(ngModel)]="selectedModule" optionLabel="name" appendTo="body"
            (onChange)="getChannels()" class="filterDD">
        </p-dropdown>
    </div>
    <div class="p-col-3">
        <p-dropdown [options]="channelList" [(ngModel)]="selectedChannel" optionLabel="name" appendTo="body"
            (onChange)="selectChannel()" class="filterDD">
        </p-dropdown>
    </div>
</div>
<p-table [value]="allSections" dataKey="id">
    <ng-template pTemplate="header">
        <tr>
            <th>Name</th>
            <th>Label Name</th>
            <th>Module</th>
            <th>Template</th>
            <th>Active</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-section>
        <tr>
            <td>{{section.name}}</td>
            <td>{{section.labelName}}</td>
            <td>{{section.moduleName}}</td>
            <td>{{section.templateName}}</td>
            <td>{{section.isActive?'Yes':'No'}}</td>
            <td class="action">
                <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"
                    *ngIf="!section.systemGenerated"><i class="pi
            pi-pencil" (click)="showEditSection(section)"></i></span>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="{{addEditSectionHeader}}" [(visible)]="displaySectionAddEdit" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}" (onHide)=sectionForm.reset();>
    <form [formGroup]="sectionForm">
        <div class="header">
            <h5>Section Information</h5>
        </div>
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12">
                    <label>Name <span style="color: red;">*</span></label>
                    <input pInputText type="text" id="name" formControlName="labelName"/>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-6">
                    <label>Module</label>
                    <h5>{{savedSection?.moduleName}}</h5>
                </div>
                <div class="p-col-6">
                    <label>Template</label>
                    <h5>{{savedSection?.templateName}}</h5>
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="displaySectionAddEdit=false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton [disabled]="!sectionForm.valid" (click)="updateSection(sectionForm.value)"
            label="Save"></button>
    </p-footer>
</p-dialog>
